module.exports = __webpack_public_path__ + "static/a-home-behind-the-lens-image-2-800x533-4c570447296003436e9549832f2862b2.jpg";